import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useData } from "../../../DataContext";
import "./country-dropdown.css";
import { CacheProvider } from "@emotion/react";
import createEmotionCache from '@emotion/cache';
 
// Create an Emotion cache with the nonce
const nonce = document.querySelector('meta[name="csp-nonce"]')?.content || '';
const emotionCache = createEmotionCache({
  key: 'css',
  nonce: nonce, // Set the nonce here
});
 
const CountrySelect = ({ originLabel, onChange, showOrigin, showDestination, origin, destination,}) => {
  const { clients } = useData();
  const [countryList, setCountryList] = useState([]);
 
  useEffect(() => {
    const createCountryList = () => {
      return clients.commonConfig.countries
        .map((country) => ({
          value: country.code, // Use country code as value
          label: country.name, // Use country name as label
        }))
        .sort((a, b) => a.label.localeCompare(b.label)); // Sort alphabetically by country name
    };
 
    setCountryList(createCountryList()); // Set the country list state
  }, [clients]);
 
  const handleOriginChange = (selectedOption) => {
    onChange(selectedOption, destination); // Send to parent
  };
 
  const handleDestinationChange = (selectedOption) => {
    onChange(origin, selectedOption); // Send to parent
  };
 
  return (
    <div>
      {(showOrigin.toLowerCase() === "y") && (
        <div className="input-row removed-padding">
          <div className="col-sm-3 text-sm-right">
            <label htmlFor="origin" className="label-column bold-text country-gap">
              {originLabel}
            </label>
          </div>
          <div className="col-sm-9">
            <CacheProvider value={emotionCache}>
              <Select
                aria-label="Origin label"
                value={origin ? { value: origin, label: origin } : null} // Use origin prop directly
                onChange={handleOriginChange}
                options={countryList}
                isClearable
                // Enable filtering based on user input
                filterOption={(option, inputValue) => {
                  const input = inputValue.toLowerCase();
                  return (
                    option.label.toLowerCase().includes(input) ||
                    option.value.toLowerCase().includes(input)
                  );
                }}
              />
            </CacheProvider>
          </div>
        </div>
      )}
 
      {(showDestination.toLowerCase() === "y") && (
        <div className={`input-row removed-padding ${showOrigin.toLowerCase() === "y" ? 'top-gap' : ''}`}>
 
          <div className="col-sm-3 text-sm-right">
          <label htmlFor="destination" className="label-column bold-text country-gap">
              Destination:
            </label>
          </div>
          <div className="col-sm-9">
            <CacheProvider value={emotionCache}>
              <Select nonce={nonce}
                aria-label="Destination label"
                value={destination ? { value: destination, label: destination } : null} // Use destination prop directly
                onChange={handleDestinationChange}
                options={countryList}
                isClearable
                // Enable filtering based on user input
                filterOption={(option, inputValue) => {
                  const input = inputValue.toLowerCase();
                  return (
                    option.label.toLowerCase().includes(input) ||
                    option.value.toLowerCase().includes(input)
                  );
                }}
              />
            </CacheProvider>
          </div>
        </div>
      )}
    </div>
  );
};
 
export default CountrySelect;
